import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Image, Button, Modal } from 'react-bootstrap';
import './BusinessOrders.css';
import BusinessSidebar from "../../BusinessSidebar";
import Header from "../../BusinessHeaderAfterLogin";
import Footer from "../../BusinessFooterAfterLogin";
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import API from '../../../Utils/Api';
import loader from '../../../assests/loader.gif';
import moment from 'moment/moment';
import { Link } from 'react-router-dom';
import { gettoastsuccess, gettoastwarning } from '../../../Utils/Common';

const options = [
    { label: 'All', value: '', image: '../assets/images/discounticn.webp' },
    { label: 'Pending', value: 0, image: '../assets/images/esdicn.webp' },
    { label: 'Redeemed', value: 1, image: '../assets/images/sddicn.webp' },
];


const BusinessOrders = () => {

    const [loading, setLoading] = useState(true);

    const [date_filter, setDate_filter] = useState('');
    const [pagination, setPagination] = useState('');
    const [deal, setDeal] = useState([]);
    const [keyword, setKeyword] = useState('');

    //const [inputs, setInputs] = useState({ customer_name: '' });

    const business_id = localStorage.getItem('business_id');

    useEffect(() => {
        document.title = `Business Orders | Local Bells`;
        document.getElementById('bodywrap').className = 'busiorder';


        let formData = new FormData();
        formData.append('business_id', business_id);
        formData.append('per_page', '');
        formData.append('page', 1);
        var url = 'get_business_my_deal';

        API.post(url, formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {

                    // console.log('number ' + response.data.data.pagination.current_page)
                    setPagination(response.data.data.pagination);
                    setDeal(response.data.data.deal);

                    // console.log('success');
                    /*setInputs({
                        customer_name: response.data.data.customer_name,
                    });*/


                }
            }).catch(error => {
                setLoading(false);
            });

    }, [business_id]);

    // State to toggle sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };

    const [selected, setSelected] = useState('');

    const handleChange = (value) => {
        setLoading(true);
        setSelected(value);
        // console.log("testing " + event);

        let formData = new FormData();
        formData.append('business_id', business_id);
        formData.append('per_page', '');
        formData.append('page', 1);
        formData.append('type', value);
        formData.append('date_filter', date_filter);
        formData.append('keyword', keyword);
        var url = 'get_business_my_deal';

        API.post(url, formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                    setPagination(response.data.data.pagination);
                    setDeal(response.data.data.deal);

                }
            }).catch(error => {
                setLoading(false);
            });

    };

    const handleFilter = (value) => {

        setLoading(true);
        setDate_filter(value);
        // console.log("testing " + event);


        let formData = new FormData();
        formData.append('business_id', business_id);
        formData.append('per_page', pagination.per_page);
        formData.append('page', pagination.current_page);
        formData.append('type', selected);
        formData.append('date_filter', value);
        formData.append('keyword', keyword);
        var url = 'get_business_my_deal';

        API.post(url, formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                    // console.log('success');
                    setPagination(response.data.data.pagination);
                    setDeal(response.data.data.deal);

                }
            }).catch(error => {
                setLoading(false);
            });

    };


    const getdeal = () => {
        setLoading(true);

        var currentpage = pagination.current_page + 1;
        let formData = new FormData();
        formData.append('business_id', business_id);
        formData.append('per_page', pagination.per_page);
        formData.append('page', currentpage);
        formData.append('type', selected);
        formData.append('date_filter', date_filter);
        formData.append('keyword', keyword);
        var url = 'get_business_my_deal';

        API.post(url, formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                    // console.log('success');
                    setPagination(response.data.data.pagination);
                    // setDeal(response.data.data.deal);

                    setDeal(prevDeals => [...prevDeals, ...response.data.data.deal]);

                }
            }).catch(error => {
                setLoading(false);
            });
    }

    /* Start Value set */
    const handleInputChange = (event) => {
        event.persist();
        setKeyword(event.target.value);

    }
    /* End Value set */
    const search = () => {
        setLoading(true);
        let formData = new FormData();
        formData.append('business_id', business_id);
        formData.append('per_page', pagination.per_page);
        formData.append('page', pagination.current_page);
        formData.append('type', selected);
        formData.append('date_filter', date_filter);
        formData.append('keyword', keyword);
        var url = 'get_business_my_deal';;

        API.post(url, formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                    // console.log('search success');
                    setPagination(response.data.data.pagination);
                    setDeal(response.data.data.deal);
                }
            }).catch(error => {
                setLoading(false);
            });
    }

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [selectedDealId, setSelectedDealId] = useState(null);

    const handleYes = (e) => {
        e.preventDefault();

        // console.log('testing ' + selectedDealId);

        let formData = new FormData();
        formData.append('business_id', business_id);
        formData.append('deal_clipped_id', selectedDealId);
        API.post('deal_clipped_status_change_by_business', formData)
            .then(response => {
                if (response.data.status === false) {
                    //setError(response.data.message);
                    setLoading(false);
                    setShow(false)
                    gettoastwarning(response.data.message, '');
                } else {
                    setLoading(false);
                    setShow(false)

                    setDeal(prevDeals =>
                        prevDeals.map(deal =>
                            deal.deal_clipped_id === selectedDealId
                                ? {
                                    ...deal,
                                    redeem_status: 1,
                                }
                                : deal
                        )
                    );

                    gettoastsuccess(response.data.message, '');
                }
            }).catch(error => {
                setLoading(false);
                gettoastwarning("Something went wrong. Please try again later.", '');
            });

    };

    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <BusinessSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />
                            <div className='nei-cont'>
                                <Row className='date-top'>
                                    <Col md={6}>
                                        <h3>My Order</h3>
                                    </Col>
                                    <Col md={6}>
                                        <div className='ldsearch ord-search'>
                                            <div>
                                                <InputGroup className="mb-0">
                                                    <InputGroup.Text id="search" className='lds-left'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/search.webp'} className="img-fluid" alt="search" />
                                                    </InputGroup.Text>
                                                    <Form.Control
                                                        placeholder="Search by Customer Name or Coupon Code"
                                                        aria-label="search"
                                                        aria-describedby="search"
                                                        name="keyword"
                                                        onChange={handleInputChange} value={keyword}
                                                    />
                                                    <InputGroup.Text id="search" className='lds-right'>
                                                        <Button onClick={search}>
                                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/search-wh.webp'} className="img-fluid" alt="search" />
                                                        </Button>
                                                    </InputGroup.Text>
                                                </InputGroup>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={12} className='mdeal-top'>
                                        <div className=''>
                                            <div className="">
                                                <div className="d-flex align-items-center justify-content-center">
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/sort.webp'} className="img-fluid deal-sort-icn" alt="sort" />
                                                    <div className='d-flex deal-filter-box'>
                                                        {options.map((option) => {
                                                            const isSelected = selected === option.value;
                                                            //const isNotAll = option.value !== 'option1';

                                                            const isActive = isSelected;

                                                            return (
                                                                <label
                                                                    key={option.value}
                                                                    className={isActive ? 'active' : ''}
                                                                >

                                                                    <Button
                                                                        variant={isSelected ? 'act' : 'gen'}
                                                                        className={isActive ? 'active' : ''}
                                                                        onClick={() => handleChange(option.value)}
                                                                    >
                                                                        {option.label}
                                                                    </Button>
                                                                </label>
                                                            );
                                                        })}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div>
                                            <div className='date-filter'>
                                                <Dropdown onSelect={handleFilter}>
                                                    <Dropdown.Toggle variant="success" id="filter">
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/leicn.webp'} className="img-fluid" alt="leicn" />
                                                        <h6>Current Month</h6>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className='date-drop'>
                                                        <Dropdown.Item eventKey="current_month" >Current Month</Dropdown.Item>
                                                        <Dropdown.Item eventKey="6_month">6 Months</Dropdown.Item>
                                                        <Dropdown.Item eventKey="1_year">1 Year</Dropdown.Item>
                                                        <Dropdown.Item eventKey="all_time">All time</Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>

                                {deal.map((val, index) => {
                                    return (
                                        <div className='mdeal-single' key={index}>
                                            <div className='mds-top'>
                                                <h6>Deal ID : <span className='fw-600'>#{val.deal_unique_id}</span></h6>
                                                <h6>Purchases Date :  <span className='fw-600'>{moment(val.purchases_date).format("DD/MM/YY")}</span></h6>
                                            </div>
                                            <div className='mds-bot'>
                                                <Row>
                                                    <Col xs="auto" className='align-items-center d-flex'>
                                                        <Image src={val.image && val.image !== "" ? val.image : process.env.REACT_APP_BASE_URL + 'assets/images/nif.jpg'} className="img-fluid" alt="md1" />
                                                    </Col>
                                                    <Col className='mds-mid-cont'>
                                                        <h4>{val.listing_title}</h4>
                                                        <h6><div
                                                        dangerouslySetInnerHTML={{
                                                            __html: val.description.replace(/\n/g, "<br/>")
                                                        }}
                                                    ></div></h6>
                                                        <div className='mds-dd'>
                                                            {(() => {
                                                                if (val.deal_master_type === 'specific') {
                                                                    if (val.deal_type === 1) {
                                                                        return (<><h6>Deal Details :</h6>
                                                                            <strike className="me-2"><h6>Rs. {val.original_mrp}</h6></strike><h6>Rs. {val.sale_price}</h6>
                                                                            <h6 class="peroff">{val.discount}% off</h6>
                                                                        </>)
                                                                    } else if (val.deal_type === 2) {
                                                                        return (<><h6>Deal Details :</h6>
                                                                            <h6>Buy {val.buy_qty} Get {val.get_qty}</h6>
                                                                        </>)
                                                                    }
                                                                } else if (val.deal_master_type === 'general') {
                                                                    if (val.deal_type === 3) {
                                                                        return (<><h6>Deal Details :</h6>
                                                                            <h6>{val.store_percent_discount}% OFF</h6>
                                                                        </>)
                                                                    } else if (val.deal_type === 4) {
                                                                        return (<><h6>Deal Details :</h6>
                                                                            <h6>{val.store_cash_discount} OFF</h6>
                                                                        </>)
                                                                    }
                                                                } else if (val.deal_master_type === 'free') {
                                                                    return (<><h6>Deal Details :</h6>
                                                                        <h6 className="text-danger">FREE Shaving</h6>
                                                                    </>)
                                                                }
                                                            })()}
                                                        </div>
                                                        <div>
                                                            <p>Coupon Code : <span className='fw-500'>#{val.coupon_code}</span></p>
                                                            {val.redeemed_on && (<p>Redeemed on : <span className='fw-500'>{moment(val.redeemed_on).format("DD/MM/YY")}</span></p>)}
                                                            {val.deal_end_date && (<p className='exp-date'>Expire on :  <span className='fw-500'>{moment(val.deal_end_date).format("DD/MM/YY")}</span></p>)}
                                                        </div>
                                                    </Col>
                                                    <Col xs="auto" className='mds-right'>
                                                        <h6>Customer name :  <span className='fw-600'>{val.customer_name}</span></h6>
                                                        <h6>Contact :  <span className='fw-600'>{val.customer_contact_number}</span></h6>

                                                        {val.redeem_status !== 1 ? (<Link to="" onClick={(e) => {
                                                            e.preventDefault();
                                                            setSelectedDealId(val.deal_clipped_id);
                                                            handleShow();
                                                        }}
                                                        ><h6 className='mds-dark'>Redeem</h6></Link>) : (<h6 className='mds-light'>Redeemed</h6>)}

                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    );
                                })}

                                {/* <div className='mdeal-single'>
                                    <div className='mds-top'>
                                        <h6>Deal ID : <span className='fw-600'>#3632</span></h6>
                                        <h6>Purchases Date :  <span className='fw-600'>5/1/2025</span></h6>
                                    </div>
                                    <div className='mds-bot'>
                                        <Row>
                                            <Col xs="auto" className='align-items-center d-flex'>
                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/md1.webp'} className="img-fluid" alt="md1" />
                                            </Col>
                                            <Col className='mds-mid-cont'>
                                                <h4>Buy 1 Get 1 Cupcakes</h4>
                                                <h6>Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups.</h6>
                                                <div className='mds-dd'>
                                                    <h6>Deal Details : <span className='fw-600'>₹ 1700</span></h6>
                                                    <h6 className='strike'>₹2,500</h6>
                                                </div>
                                                <div>
                                                    <p>Coupon Code : <span className='fw-500'>#CUP1234</span></p>
                                                    <p>Redeemed on : <span className='fw-500'>5/2/2025 8:00 PM (IST)</span></p>
                                                    <p className='exp-date'>Expire on :  <span className='fw-500'>30 May, 2025</span></p>
                                                </div>
                                            </Col>
                                            <Col xs="auto" className='mds-right'>
                                                <h6>Customer name :  <span className='fw-600'>Nikhil Gujarathi</span></h6>
                                                <h6>Contact :  <span className='fw-600'>707-794-7044</span></h6>
                                                <h6 className='mds-light'>Redeemed</h6>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                                <div className='mdeal-single'>
                                    <div className='mds-top'>
                                        <h6>Deal ID : <span className='fw-600'>#3632</span></h6>
                                        <h6>Purchases Date :  <span className='fw-600'>5/1/2025</span></h6>
                                    </div>
                                    <div className='mds-bot'>
                                        <Row>
                                            <Col xs="auto" className='align-items-center d-flex'>
                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/md2.webp'} className="img-fluid" alt="md2" />
                                            </Col>
                                            <Col className='mds-mid-cont'>
                                                <h4>₹500 Off Custom Furniture</h4>
                                                <h6>Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups.</h6>
                                                <div className='mds-dd'>
                                                    <h6>Deal Details : <span className='fw-600'>₹ 1700</span></h6>
                                                    <h6 className='strike'>₹2,500</h6>
                                                </div>
                                                <div>
                                                    <p>Coupon Code : <span className='fw-500'>#CUP1234</span></p>
                                                    <p className='exp-date'>Expire on :  <span className='fw-500'>30 May, 2025</span></p>
                                                </div>
                                            </Col>
                                            <Col xs="auto" className='mds-right'>
                                                <h6>Customer name :  <span className='fw-600'>Nikhil Gujarathi</span></h6>
                                                <h6>Contact :  <span className='fw-600'>707-794-7044</span></h6>
                                                <h6 className='mds-dark'>Redeem</h6>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                                <div className='mdeal-single'>
                                    <div className='mds-top'>
                                        <h6>Deal ID : <span className='fw-600'>#3632</span></h6>
                                        <h6>Purchases Date :  <span className='fw-600'>5/1/2025</span></h6>
                                    </div>
                                    <div className='mds-bot'>
                                        <Row>
                                            <Col xs="auto" className='align-items-center d-flex'>
                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/md1.webp'} className="img-fluid" alt="md1" />
                                            </Col>
                                            <Col className='mds-mid-cont'>
                                                <h4>Flat 40% Off Salwar Suits</h4>
                                                <h6>Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups.</h6>
                                                <div className='mds-dd'>
                                                    <h6>Deal Details : <span className='fw-600'>₹ 1700</span></h6>
                                                    <h6 className='strike'>₹2,500</h6>
                                                </div>
                                                <div>
                                                    <p>Coupon Code : <span className='fw-500'>#CUP1234</span></p>
                                                    <p>Redeemed on : <span className='fw-500'>5/2/2025 8:00 PM (IST)</span></p>
                                                    <p className='exp-date'>Expire on :  <span className='fw-500'>30 May, 2025</span></p>
                                                </div>
                                            </Col>
                                            <Col xs="auto" className='mds-right'>
                                                <h6>Customer name :  <span className='fw-600'>Nikhil Gujarathi</span></h6>
                                                <h6>Contact :  <span className='fw-600'>707-794-7044</span></h6>
                                                <h6 className='mds-light'>Redeemed</h6>
                                            </Col>
                                        </Row>
                                    </div>
                                </div> */}


                                <Row class="mb-5">
                                    <Col md={4}>
                                        <div className='ne-box mb-4'>
                                            <h6>Need Help?</h6>
                                            <h6 className='fw-500 mb-1'>Email: support@localbells.com</h6>
                                            <h6 className='fw-500 mb-0'>Call/WhatsApp: +91 8484040933</h6>
                                        </div>
                                    </Col>
                                </Row>
                                {/* <Row className='text-center load-more'>
                                    <Col md={12}>
                                        <Link to="" className='blue-link'>Load More</Link>
                                    </Col>
                                </Row> */}

                                {deal.length < pagination.total && (
                                    <Row className='text-center load-more'>
                                        <Col md={12}>
                                            <Link to="" onClick={getdeal} className='blue-link'>Load More</Link>
                                        </Col>
                                    </Row>)}

                                <div className='footer-org footer'>
                                    <Footer />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                centered
                className='redeem-modal'
            >

                <Modal.Body>
                    <Row>
                        <Col md={12}>
                            <h3 className='text-center'>Do you confirm to Redeem?</h3>
                        </Col>
                        <Col md={6}>
                            <Link to="" onClick={handleClose} className='grey-link'>No</Link>
                        </Col>
                        <Col md={6}>
                            <Link to="" onClick={handleYes} className='blue-link'>Yes</Link>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>

            {loading && (
                <div className="loadingClass">
                    <img src={loader} alt="loader" />
                </div>
            )}
        </>
    )
}

export default BusinessOrders;


